import { Pipe, PipeTransform } from '@angular/core';
import { FeatureName } from 'src/app/common/feature-name';

@Pipe({
  name: 'featureIcon',
  standalone: true
})
export class FeatureIconPipe implements PipeTransform {
  transform(feature: string | null | undefined): string {
    const normalized = (feature ?? '').trim();

    switch (normalized) {
      case FeatureName.Kunder:
        return 'fas fa-users';
      case FeatureName.Skabeloner:
        return 'fas fa-right-left';
      case FeatureName.Synkroniseringer:
        return 'fas fa-rotate';
      case FeatureName.Adgange:
        return 'fa-solid fa-user-lock';
      default:
        return 'fas fa-arrow-right';
    }
  }
}
